import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=1d8a4f61&"
import script from "./SiteHeader.vue?vue&type=script&lang=ts&"
export * from "./SiteHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=1d8a4f61&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/_locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fshared%2FSiteHeader.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./_locales/common.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fshared%2FSiteHeader.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "@/components/shared/_locales/single.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fshared%2FSiteHeader.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports